/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronLeftPipe = createReactComponent(
  "chevron-left-pipe",
  "IconChevronLeftPipe",
  [
    ["path", { d: "M7 6v12", key: "svg-0" }],
    ["path", { d: "M18 6l-6 6l6 6", key: "svg-1" }]
  ]
);

export { IconChevronLeftPipe as default };
//# sourceMappingURL=IconChevronLeftPipe.js.map
